// 用户token信息
export const TokenKeys = {
  ACCESS_TOKEN: 'access_token',
  SESSION_TOKEN: 'session_token',
  REFRESH_TOKEN: 'refresh_token',
  ACCOUNT:'account',
  USER_CODE:'user_code',
  SHARE_USER_CODE:'self_code',
  TOKEN_CODE:'token_code',
  USER_NAME:'user_name',
  USER_IMG:'user_img',
  TEMP_ID:'',//模板id
  DEFAULT_USER_PHOTO:'https://cdn.i31.com/oss/img/user/user.png',
  URL_DATA:'url_data',
  SESSION_TIME:10*60*60*1000,
  ACTIVITY_CODE:'code',
  PRODUCT_ENV: 'productEnv',
  API_SIGN:'api_sign',
  SALT:'XIJKIEJDJ9J098#$JH3H0001//22P',
  // WEB_HOST:'https://manage.i31.com/AICard_H5/index.html#/',
  WEB_HOST:'https://manage.i31.com/test_public/index.html#/',
  // WEB_HOST:'http://192.168.1.146:1024/index.html#/',
  OSS_DOMAIN:'https://cdn.i31.com',
};



// WEBPACK FOOTER //
// ./src/common/js/variable.js